import React, { useContext, useState } from 'react'
import StabilityImprovement from '../../../../assets/backgrounds/stability-improvement.svg'
import StabilityImprovementDesktop from '../../../../assets/backgrounds/stability-improvement-desktop.svg'
import ActivityImprovement from '../../../../assets/backgrounds/activity-improvement.svg'
import ActivityImprovementDesktop from '../../../../assets/backgrounds/activity-improvement-desktop.svg'
import YieldImprovement from '../../../../assets/backgrounds/yield-improvement.svg'
import YieldImprovementDesktop from '../../../../assets/backgrounds/yield-improvement-desktop.svg'
import RedesignImprovement from '../../../../assets/backgrounds/redesign-improvement.svg'
import RedesignImprovementDesktop from '../../../../assets/backgrounds/redesign-improvement-desktop.svg'
import { FormattedMessage } from 'react-intl'
import SolutionCard from './components/SolutionCard'
import { Waypoint } from 'react-waypoint'
import SectionWithTag from '../../../../components/SectionWithTag'
import PaddingContext from '../../../../utils/PaddingContext'

const id = 'page.epp.improvement'

const solutionCards = [
    {
        id: `${id}.stability`,
        className: 'bg-green-light',
        background: {
            mobileComponent: StabilityImprovement,
            component: StabilityImprovementDesktop,
            className: 'mix-blend-multiply',
        },
    },
    {
        id: `${id}.activity`,
        className: 'bg-sand',
        background: {
            mobileComponent: ActivityImprovement,
            component: ActivityImprovementDesktop,
            className: 'mix-blend-multiply',
        },
    },
    {
        id: `${id}.yield`,
        className: 'bg-purple-light',
        background: {
            mobileComponent: YieldImprovement,
            component: YieldImprovementDesktop,
            className: 'mix-blend-multiply',
        },
    },
    {
        id: `${id}.redesign`,
        className: 'bg-sand-light',
        background: {
            mobileComponent: RedesignImprovement,
            component: RedesignImprovementDesktop,
            className: 'mix-blend-multiply',
        },
    },
]

const Improvement = () => {
    const { padding } = useContext(PaddingContext)
    const [visible, setVisible] = useState(false)

    return (
        <div className='py-12 md:py-30 bg-white relative'>
            <SectionWithTag
                tag={{ id: `${id}.tag`, className: 'pr-0' }}
                className='3xl:max-w-screen-2xl mx-auto'
                padding={padding}
            >
                <div className='md:w-[800px] pt-9 md:pt-0'>
                    <FormattedMessage id={id} tagName='h2' />
                </div>
            </SectionWithTag>
            <div className='side-padding 3xl:max-w-screen-2xl mx-auto'>
                <Waypoint onEnter={() => setVisible(true)}>
                    <div className='grid pt-12 md:pt-20 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-x-6 lg:gap-x-8 xl:gap-x-10'>
                        {solutionCards.map((card, index) => (
                            <div
                                key={card.id}
                                style={{
                                    transform: visible
                                        ? 'translate3d(0px, 0px, 0px)'
                                        : 'translate3d(0px, 200px, 0px)',
                                    opacity: visible ? 1 : 0,
                                    transitionDelay: `${300 * (index + 1)}ms`,
                                }}
                                className='transition ease-out duration-1000'
                            >
                                <SolutionCard solution={card} />
                            </div>
                        ))}
                    </div>
                </Waypoint>
            </div>
        </div>
    )
}

export default Improvement
